import PredictionRepository from "./repositories/predictionRepository";
import LimitRepository from "./repositories/limitRepository";

const repositories = {
    predictions : PredictionRepository,
    limits : LimitRepository,
};

export const RepositoryFactory = {
  get: name => repositories[name]
};